import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class EErgoFormService {
  private readonly eErgoFormBaseApiUrl: string;

  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.eErgoFormBaseApiUrl = `${baseUrl}api/e-ergo-form`;
  }

  public createForm(data: any) {
    let eErgoCreateFormApiUrl = `${this.eErgoFormBaseApiUrl}/create`;

    return this.dataService.post<any>(eErgoCreateFormApiUrl, data);
  }

  public getForm(type: string, formId: string) {
    let eErgoGetFormApiUrl = `${this.eErgoFormBaseApiUrl}/${type}/${formId}`;

    return this.dataService.get<any>(eErgoGetFormApiUrl);
  }

  public getOpenForms(emailAddress: string, continuationToken: string) {
    let eErgoGetOpenFormApiUrl = `${this.eErgoFormBaseApiUrl}/get-open-forms/${btoa(emailAddress)}`;

    return this.dataService.get<any>(eErgoGetOpenFormApiUrl, continuationToken);
  }

  public getOpenFormsForEmployee(type: string, emailAddress: string, employeeName: string, employeeEmail: string, continuationToken: string) {
    let eErgoGetOpenFormApiUrl;

    if (employeeEmail) {
      eErgoGetOpenFormApiUrl = `${this.eErgoFormBaseApiUrl}/get-open-forms/${type}/${btoa(emailAddress)}/${btoa(employeeName)}/${btoa(employeeEmail)}`;
    } else {
      eErgoGetOpenFormApiUrl = `${this.eErgoFormBaseApiUrl}/get-open-forms/${type}/${btoa(emailAddress)}/${btoa(employeeName)}`;
    }

    eErgoGetOpenFormApiUrl = `${this.eErgoFormBaseApiUrl}/get-open-forms/${type}/${btoa(emailAddress)}/${btoa(employeeName)}/${btoa(employeeEmail)}`;

    return this.dataService.get<any>(eErgoGetOpenFormApiUrl, continuationToken);
  }

  public submitForm(type: string, formId: string, submitFormData: any) {
    let eErgoSubmitFormApiUrl = `${this.eErgoFormBaseApiUrl}/${type}/${formId}/submit`;

    return this.dataService.post<any>(eErgoSubmitFormApiUrl, submitFormData);
  }

  public updateForm(type: string, formId: string, updateFormData: any) {
    let eErgoUpdateFormApiUrl = `${this.eErgoFormBaseApiUrl}/${type}/${formId}/submit`;

    return this.dataService.put<any>(eErgoUpdateFormApiUrl, updateFormData);
  }

  public uploadFiles(formId: string, formData: any) {
    let eErgoUploadFileApiUrl = `${this.eErgoFormBaseApiUrl}/upload?formId=${formId}`;

    return this.dataService.post<any>(eErgoUploadFileApiUrl, formData);
  }

  public deleteFile(fileName: string, relativePath: string) {
    var data = {
      name: btoa(fileName),
      relativePath: btoa(relativePath)
    }

    let eErgoDeleteFileApiUrl = `${this.eErgoFormBaseApiUrl}/delete`;

    return this.dataService.post<any>(eErgoDeleteFileApiUrl, data);
  }

  public downloadFile(fileName: string, relativePath: string) {
    var data = {
      name: btoa(fileName),
      relativePath: btoa(relativePath)
    }

    let fileApiUrl = `${this.eErgoFormBaseApiUrl}/download`;

    return this.dataService.postFile(fileApiUrl, data);
  }
}
